import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';

@Component({
  selector: 'app-uhbvn',
  templateUrl: './uhbvn.component.html',
  styleUrls: ['./uhbvn.component.scss']
})
export class UhbvnComponent implements OnInit {
  constructor(
    private route: ActivatedRoute, 
    private cryptoJsService: CryptoJsService, 
    private router: Router,
    private activityRecordService: ActivityRecordService
    ) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;
  userID: any;

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


    let parentRoute = this.router.url.split('/')[1];

    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.items = [
          { label: 'Upload Letter For Survey', routerLink: `/${parentRoute}/uhbvn/upload-noc`},
          { label: 'JE Survey', routerLink: `/${parentRoute}/uhbvn/uploaded-noc-survey` },
          // { label: 'Further Action Taken', routerLink: `/${parentRoute}/pre-estimate-survey/approved` },
          
        ];
      }
      );

  }
}